import React, { Component } from 'react';

import { IconButton } from 'office-ui-fabric-react/lib/Button';
import { Dropdown } from 'office-ui-fabric-react/lib/Dropdown';

import { CHART_COLORS } from '../../../utilities/colors';
import { Icon } from 'office-ui-fabric-react';

class LineStyles extends Component {
  state = {
    openLineKey: ''
  };

  render(){
    const { plot, plotIndex } = this.props;
    return (
      <div className='filters panel-body'>
        <div style={{paddingRight: '37px'}}>
          {
            plot.data && plot.data.map((each, index) => {
              let isOpen = false;
              if(each.key === this.state.openLineKey){ isOpen = true };
              return (
                <div className='line-style' key={`${each.key}-${index}`}>
                  <div className='open-edit-toggle'>
                    <div className='left-col'>
                      <IconButton
                        className='line-toggle'
                        iconProps={ each.visible ? { iconName: 'CircleFill', style: { color: each.line.color } } : { iconName: 'CircleAdditionSolid', style: { color: '#c9c9c9' } } }
                        title={`${each.visible ? 'Hide' : 'Show'} Line`}
                        ariaLabel={`${each.visible ? 'Hide' : 'Show'} Line`}
                        onClick={() => this.props.editTrace({visible: !each.visible}, plotIndex, each.key)}
                      />
                      <span className='line-name'>{each.name}</span>
                    </div>
                    <IconButton
                      className='open-line styles'
                      iconProps={{ iconName: isOpen ? 'Uneditable' : 'Edit' }}
                      title="Edit Line Styles"
                      ariaLabel="Edit Line Styles"
                      onClick={() => this.setState({openLineKey: isOpen ? '' : each.key})}
                    />
                    
                  </div>
                  {
                    this.state.openLineKey === each.key ? (
                      <div className='editor' style={{backgroundColor: '#eaeaea'}}>
                        <Dropdown
                          placeholder="Select an Dash Type"
                          label="Dash Style:"
                          id="dash-dropdown"
                          ariaLabel="Dash Dropdown"
                          selectedKey={ each.line.dash }
                          options={[
                            { key: 'solid', text: 'Solid' },
                            { key: 'dot', text: 'Dot' },
                            { key: 'dash', text: 'Dash' },
                            { key: 'longdash', text: 'Long Dash' },
                            { key: 'dashdot', text: 'Dash Dot' },
                            { key: 'longdashdot', text: 'Long Dash Dot' }
                          ]}
                          onChange={(e, {key}) => {
                            this.props.editChartLineStyles({dash: key}, plotIndex, each.key)
                          }}
                        />
                        <Dropdown
                          placeholder="Select a Color"
                          label="Color:"
                          id="color-dropdown"
                          ariaLabel="Dash Dropdown"
                          selectedKey={ each.line.color }
                          onRenderTitle={(item) => {
                            let key = item[0].key;
                            return <div className='custom-dropdown' key={`title-${key}`}>
                              <Icon style={{ marginRight: '8px', color: key }} iconName='CircleFill'/>
                            </div>
                          }}
                          onRenderItem={({key}) => {
                            return (
                              <div 
                                className='custom-dropdown' 
                                key={key} 
                                onClick={() => {
                                  this.props.editTrace({
                                    line: {
                                      ...each.line,
                                      color: key
                                    },
                                    hoverlabel: {
                                      ...each.hoverlabel,
                                      bordercolor: key
                                    }
                                  }, plotIndex, each.key)
                                }}
                              >
                                <Icon style={{ marginRight: '8px', color: key }} iconName='CircleFill'/>
                              </div>
                            )
                          }}
                          options={CHART_COLORS.map(color => ({key: color, text: color}))}
                          onChange={(e, {key}) => this.props.editTrace({
                            line: {
                              ...each.line,
                              color: key
                            },
                            hoverlabel: {
                              ...each.hoverlabel,
                              bordercolor: key
                            }
                          }, plotIndex, each.key)}
                        />
                        <Dropdown
                          placeholder="Line Width"
                          label="Width:"
                          id="width-dropdown"
                          ariaLabel="Width Dropdown"
                          selectedKey={ each.line.width }
                          options={[1,2,3,4,5,6,7,8,9,10].map(item => ({key: item, text: `${item}px`}))}
                          onChange={(e, {key}) => {
                            this.props.editChartLineStyles({width: key}, plotIndex, each.key)
                          }}
                        />
                      </div>
                    ) : null
                  }
                </div>
              )
            })
          }
        </div>
      </div>
    )
  }
};

export default LineStyles;


// WEBPACK FOOTER //
// ./src/components/panel/items/LineStyles.js